import { OrgSettings } from "@/types/index";

export class OrganisationSettings implements OrgSettings {
  private _data: OrgSettings;
  constructor(data: OrgSettings) {
    this._data = data;
  }

  /* normalize(data: OrgSettingsV1): OrgSettings {
    return {
      layoutSettings: data.LayoutSettings,
      applicationSettings: data.ApplicationSettings,
      addressSettings: data.AutoaddressSettings,
      businessLines: data.BusinessLines,
      mapSettings: {
        mapOptions: data.mapOptions,
        baseMaps: data.baseMaps,
        sources: data.sources,
        layers: data.layers
      }
    };
  } */

  get layoutSettings() {
    return this._data.layoutSettings;
  }

  get applicationSettings() {
    return this._data.applicationSettings;
  }

  get addressSettings() {
    return this._data.addressSettings;
  }

  get businessLines() {
    return this._data.businessLines;
  }

  get mapSettings() {
    return this._data.mapSettings;
  }

  get layers() {
    return this._data.mapSettings.layers;
  }

  get sources() {
    return this._data.mapSettings.sources;
  }

  get baseMaps() {
    return this._data.mapSettings.baseMaps;
  }

  get mapOptions() {
    return this._data.mapSettings.mapOptions;
  }
}
